export default __webpack_public_path__ + "static/media/built-poly.bb6ef9f5.png";